import useSWR from "swr";
import {OffersCountDto} from "../../../services/api";

export const useOffersCount = (week: number, year: number, condition: boolean) => {
    const key = `/api/offers/count?week=${week}&year=${year}`;
    const {data, isLoading, error} = useSWR<OffersCountDto, Error>(condition ? key : null);

    return {
        mutationKey: key,
        data,
        isLoading,
        error
    }
}
